"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (country) {
  return currencyMap[country.toUpperCase()] || currencyMap.USA;
};

/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

// Return the ISO 4217 currency code that AuctionEx uses in a country.
// You must provide a ISO 3166-1 alpha-3 code.
// countryCurrency

var currencyMap = {
  CAN: "CAD",
  USA: "USD"
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/configurations/lib/common/countryCurrency.js
// module id = 74
// module chunks = 9 10 11 12 13 14 15 18 19 20 21 22 23 24 25 26 27 28 29 30 33 34 35 38 39 40 41 42 43 45 46 47 48 49 50 51 54